import { t } from '@lingui/macro';
import React from 'react';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import styles from '../FilterSidebar.module.css';

const AggScooterBalanceComponent = () => (
    <div>
        <div style={{ padding: '10px' }}>
            <small>{t`Агрегированный баланс самокатов на парковках`}</small>
        </div>
        <div className={styles.aggScootersBalanceContainer}>
            <div className={styles.listItemGeneric}>&lt; -10</div>
            <div className={styles.listItemGeneric}>-5</div>
            <div className={styles.listItemGeneric}>0</div>
            <div className={styles.listItemGeneric}>5</div>
            <div className={styles.listItemGeneric}>&gt; 10</div>
        </div>
        <div style={{ padding: '10px' }}>
            <small>
                {t`дефицит`}
                {'(-) / '}
                {t`избыток`}
                {'(+)'}
            </small>
        </div>
    </div>
);

export const AggScooterBalanceLegend = withDisplayedLayersCheck(
    AggScooterBalanceComponent,
    t`Агрегированный баланс самокатов на парковках`
);
